import React, { useContext } from 'react';
export const UploadContext = React.createContext({
    uploadFinished: false,
    uploadProgress: 0,
});
export const useUploadStatus = () => useContext(UploadContext);
